module.exports = __webpack_public_path__ + "img/search.971a600a.svg";